var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "m-6 p-6 mobile:p-4 max-w-xl w-full max-h-full bg-white overflow-y-auto rounded-sm"
    },
    [
      _c(
        "div",
        { staticClass: "mb-6 mobile:mb-4 flex justify-between items-center" },
        [
          _c(
            "h1",
            { staticClass: "tablet:text-2xl mobile:text-xl", style: _vm.font },
            [_vm._v("\n      " + _vm._s(_vm.$t("SUBSCRIBE")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { title: _vm.$t("A11Y.CLOSE") },
              on: { click: _vm.close }
            },
            [_c("icon", { attrs: { "aria-hidden": "true", type: "close" } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("divider", { staticClass: "mb-6", attrs: { color: _vm.shadeBase } }),
      _vm._v(" "),
      _c("client-list", { on: { click: _vm.finish } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }